import { render, staticRenderFns } from "./muteToggle.vue?vue&type=template&id=22fdba70&"
import script from "./muteToggle.vue?vue&type=script&lang=js&"
export * from "./muteToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/path0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22fdba70')) {
      api.createRecord('22fdba70', component.options)
    } else {
      api.reload('22fdba70', component.options)
    }
    module.hot.accept("./muteToggle.vue?vue&type=template&id=22fdba70&", function () {
      api.rerender('22fdba70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "static/muteToggle.vue"
export default component.exports